import React from 'react'
import { Link } from 'react-router-dom';

const Software_release = () => {
  const handleSelect = (product) => {
    sessionStorage.setItem('selectedProduct', product);
    // opcional: window.scrollTo(0, 0);
  };

  return (
    <>
      <section class="relative">
        <img
          class="absolute inset-0 object-[75%] sm:object-[25%] object-cover w-full h-full opacity-85 sm:opacity-100"
          src="https://images.pexels.com/photos/6612709/pexels-photo-6612709.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          alt=""
        />
        <div className="absolute inset-0 bg-gray-900 bg-opacity-30"></div>

        <div class="hidden sm:block sm:inset-0 sm:absolute sm:bg-gradient-to-r sm:from-pirDarkGray sm:to-transparent"></div>

        <div class="relative max-w-screen-xl px-4 sm:px-6 lg:px-8 py-32 mx-auto lg:h-4/6 lg:items-center lg:flex lg:justify-center">
          <div class="max-w-3xl text-center sm:text-center">
            <div>
              <p className="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-white">
               Software release
              </p>
              <img className='w-[600px] text-center flex justify-center mx-auto' src="https://img.invupos.com/webinvu/Software%20release/HeaderSoftwareRelease.webp"/>
            </div>
            <h1 class="text-5xl text-white font-extrabold sm:text-6xl">
             Browse the latest software updates from Invu POS
            </h1>

            <p className="mt-5 max-w-2xl text-text-base lg:text-base text-gray-200 leading-loose mx-auto">
             Explore the upgrade notes for important updates about this release.
            </p>

            <div class="flex flex-wrap gap-4 mt-8 text-center justify-center">
              <button
                class="block w-full px-12 py-3 text-sm font-medium text-white rounded shadow bg-indigo-600  sm:w-auto active:bg-indigo-600  hover:bg-indigo-700 focus:outline-none focus:ring"
              >
                Support Center
              </button>

              <button
                class="block w-full px-12 py-3 text-sm font-medium bg-white rounded shadow text-indigo-600  sm:w-auto hover:text-indigo-700 active:text-indigo-500 focus:outline-none focus:ring"
                onClick={() => window.scrollTo(0, 0)}
              >
                Release Notes
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20" id="release-notes">
        <div className="max-w-screen-xl mx-auto px-8">
          <h2 className="text-5xl font-bold text-center mb-12">Release Notes</h2>
          <div className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Android POS Card */}
              <div className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-transform transform hover:scale-105">
                <div className="h-80 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:bg-[#E0F7FA]">
                  <img
                    src="https://img.invupos.com/webinvu/Software%20release/Products/Invu%20POS%203.png"
                    alt="Invu POS 3"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold">Invu POS 3</h3>
                  <Link
                    to="/software-release-details"
                    onClick={() => {
                      handleSelect('Invu POS 3');
                      window.scrollTo(0, 0);
                    }}
                    className="mt-2 block text-indigo-500 hover:underline"
                  >
                    View Release Notes
                  </Link>
                </div>
              </div>

              {/* POS iOS Card */}
              <div className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-transform transform hover:scale-105">
                <div className="h-80 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:bg-[#F3E5F5]">
                  <img
                    src="https://img.invupos.com/webinvu/Software%20release/Products/ADMINv1.png"
                    alt="POS ADMIN"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold">ADMIN</h3>
                  <Link
                    to="/software-release-details"
                    onClick={() => {
                      handleSelect('ADMIN');
                      window.scrollTo(0, 0);
                    }}
                    className="mt-2 block text-indigo-500 hover:underline"
                  >
                    View Release Notes
                  </Link>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {/* Invu Lite */}
              <div className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-transform transform hover:scale-105">
                <div className="h-80 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:bg-[#FFF3E0]">
                  <img
                    src="https://img.invupos.com/webinvu/Software%20release/Products/Invu%20KDS.png"
                    alt="Invu KDS"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4">
                  <div className='flex space-x-2'>
                    <h3 className="text-base font-medium">Invu KDS</h3>
                    <span class="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">PRÓXIMAMENTE</span>
                  </div>
                  <Link  className="mt-1 block text-sm text-indigo-500 hover:underline">
                    View Release Notes
                  </Link>
                </div>
              </div>

              {/* Invu Lite with POS */}
              <div className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-transform transform hover:scale-105">
                <div className="h-80 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:bg-[#E8F5E9]">
                  <img
                    src="https://img.invupos.com/webinvu/Software%20release/Products/Invu%20Supply.png"
                    alt="Invu Supply"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4">
                  <div className='flex space-x-2'>
                    <h3 className="text-base font-medium">Invu Supply</h3>
                    <span class="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">PRÓXIMAMENTE</span>
                  </div>
                  <Link  className="mt-1 block text-sm text-indigo-500 hover:underline">
                    View Release Notes
                  </Link>
                </div>
              </div>

              {/* Smart Terminal */}
              <div className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-transform transform hover:scale-105">
                <div className="h-80 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:bg-[#FFEBEE]">
                  <img
                    src="https://img.invupos.com/webinvu/Software%20release/Products/Invu%20Report.png"
                    alt="Smart Terminal"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4">
                  <div className='flex space-x-2'>
                    <h3 className="text-base font-medium">Invu Report</h3>
                    <span class="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">PRÓXIMAMENTE</span>
                  </div>
                  <Link  className="mt-1 block text-sm text-indigo-500 hover:underline">
                    View Release Notes
                  </Link>
                </div>
              </div>
            </div>

            {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              <div className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-transform transform hover:scale-105">
                <div className="h-64 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:bg-[#E3F2FD]">
                  <img
                    src="https://img.invupos.com/webinvu/Software%20release/Device6.png"
                    alt="Kitchen Display System"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold">Kitchen Display System</h3>
                  <Link to="/software-release-details" onClick={() => window.scrollTo(0, 0)} className="mt-2 block text-indigo-500 hover:underline">
                    View Release Notes
                  </Link>
                </div>
              </div>


              <div className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-transform transform hover:scale-105">
                <div className="h-64 flex items-center justify-center bg-gray-50 transition-colors duration-300 group-hover:bg-[#FCE4EC]">
                  <img
                    src="https://img.invupos.com/webinvu/Software%20release/Device7%281%29.png"
                    alt="Customer Display System"
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold">Customer Display System</h3>
                  <Link to="/software-release-details" onClick={() => window.scrollTo(0, 0)} className="mt-2 block text-indigo-500 hover:underline">
                    View Release Notes
                  </Link>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  )
}

export default Software_release